interface EventAddress{
    city?: string,
    state?: string,
    country?: string
}

export const formatEventAddress = ({ city, state, country } : EventAddress ) => {
    const formattedAddress = `${city || ""} ${state || ""} ${country || ""}`;
    return formattedAddress.trim();
};